// Import the animated cursor
import AnimatedCursor from 'animated-cursor';

// Create a DOM node with the specified HTML
const cursorHTML = `
    <div id="cursor">
        <div id="cursor-outer"></div>
        <div id="cursor-inner"></div>
    </div>
`;

// Function to initialize the animated cursor
export function initAnimatedCursor() {
    // Don't initialize if we're in Elementor editor
    if (document.documentElement.classList.contains('elementor-html')) {
        return;
    }

    // Append the cursor HTML to the body just before the closing body tag
    document.body.insertAdjacentHTML('beforeend', cursorHTML);

    // Using just default options
    const ac = AnimatedCursor({
        hideNativeCursor: true,
        size: { inner: 28, outer: 28 },
        hoverScale: { inner: 2, outer: 2 },
        clickScale: { inner: 2, outer: 2 },
        trailingSpeed: 1,
    });
    ac.init();

    // Get the cursor element
    const cursor = document.getElementById('cursor');

    // Handle mouse leaving the window
    window.addEventListener('mouseout', (e) => {
        // Check if mouse has left the window entirely
        if (e.relatedTarget === null) {
            cursor.style.display = 'none';
        }
    });

    // Handle mouse entering the window
    window.addEventListener('mouseover', () => {
        cursor.style.display = '';
        // Force cursor update to current mouse position
        const mouseEvent = new MouseEvent('mousemove', {
            clientX: event.clientX,
            clientY: event.clientY,
        });
        window.dispatchEvent(mouseEvent);
    });
}
